import {
    SET_SUB_ROUTE,
} from "../actions/types";

const initialState = {
    subRoute: ''
};

export default function (state = initialState, action) {
    const { payload, type } = action;

    switch (type) {
        case SET_SUB_ROUTE:
            return {
                ...state,
                subRoute: payload,
            };
        default:
            return state;
    }
}
